import { APP, WS_DATA } from './app.constants';

export const LABELS = `${APP}_labels`;

export const WS_DATA_LABEL = `${WS_DATA}/label`;
export const WS_DATA_LABELS = `${WS_DATA}/labels`;
